<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="id" label="活动ID" align="center" width="90"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center" width="90"></el-table-column>
                <el-table-column prop="nickName" label="发布用户" align="center" width="120">
                    <template slot-scope="scope">
                        <div class="user-cell">
                            <el-image
                                v-if="scope.row.header"
                                style="width: 32px; height: 32px; border-radius: 50%; margin-right: 6px;"
                                :src="scope.row.header"
                                fit="cover"
                                :preview-src-list="[scope.row.header]">
                            </el-image>
                            <span>{{ scope.row.nickName || '-' }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="theme" label="活动主题" align="center" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="activityType" label="活动门槛" align="center" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="location" label="活动地点" align="center" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="meetingPlace" label="集合地点" align="center" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="startTime" label="开始时间" align="center" width="160"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" align="center" width="160"></el-table-column>
                <el-table-column prop="capacity" label="活动人数" align="center" width="90"></el-table-column>
                <el-table-column prop="registerCount" label="已报名" align="center" width="80"></el-table-column>
                <el-table-column prop="maidan" label="买单方式" align="center" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="160"></el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="180">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-view" size="mini" @click="detailTip(scope.row)">详情</el-button>
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="活动详情" width="720px">
            <div class="dialog detail" v-if="detailData">
                <div class="item"><div class="label">活动ID</div><div class="value">{{ detailData.id }}</div></div>
                <div class="item"><div class="label">发布用户</div><div class="value">{{ detailData.nickName }}（ID: {{ detailData.userId }}）</div></div>
                <div class="item"><div class="label">活动主题</div><div class="value">{{ detailData.theme }}</div></div>
                <div class="item"><div class="label">活动门槛</div><div class="value">{{ detailData.activityType }}</div></div>
                <div class="item"><div class="label">活动地点</div><div class="value">{{ detailData.location }}</div></div>
                <div class="item"><div class="label">集合地点</div><div class="value">{{ detailData.meetingPlace }}</div></div>
                <div class="item"><div class="label">开始时间</div><div class="value">{{ detailData.startTime }}</div></div>
                <div class="item"><div class="label">结束时间</div><div class="value">{{ detailData.endTime }}</div></div>
                <div class="item"><div class="label">活动人数</div><div class="value">{{ detailData.capacity }}</div></div>
                <div class="item"><div class="label">已报名</div><div class="value">{{ detailData.registerCount }}</div></div>
                <div class="item"><div class="label">买单方式</div><div class="value">{{ detailData.maidan }}</div></div>
                <div class="item"><div class="label">创建时间</div><div class="value">{{ detailData.creationTime }}</div></div>
                <div class="item item-top"><div class="label">活动内容</div><div class="value content">{{ detailData.content }}</div></div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑活动" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">活动主题</div>
                    <div class="value">
                        <el-input v-model="editData.theme" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">活动门槛</div>
                    <div class="value">
                        <el-input v-model="editData.activityType" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">活动地点</div>
                    <div class="value">
                        <el-input v-model="editData.location" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">集合地点</div>
                    <div class="value">
                        <el-input v-model="editData.meetingPlace" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">开始时间</div>
                    <div class="value">
                        <el-date-picker
                            v-model="editData.startTime"
                            type="datetime"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择"
                            style="width: 100%">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">结束时间</div>
                    <div class="value">
                        <el-date-picker
                            v-model="editData.endTime"
                            type="datetime"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择"
                            style="width: 100%">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">活动人数</div>
                    <div class="value">
                        <el-input v-model.number="editData.capacity" size="small" type="number" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">买单方式</div>
                    <div class="value">
                        <el-input v-model="editData.maidan" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item item-top">
                    <div class="label">活动内容</div>
                    <div class="value">
                        <el-input v-model="editData.content" size="small" type="textarea" :rows="4" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="editFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'

export default {
    name: 'activity',
    components: {
        queryCondition,
    },
    data() {
        return {
            isDetailDialog: false,
            isUpdateDialog: false,
            detailData: {},
            editData: {},
            totalCount: 0,
            tableData: [],
            conditionData: {
                userId: '',
                activityType: '',
                startTime: '',
                endTime: '',
                location: '',
                theme: '',
                current: 1,
                size: 10,
            },
            queryList: [
                { type: 'input', label: '用户ID:', name: 'userId' },
                { type: 'input', label: '活动主题:', name: 'theme' },
                { type: 'input', label: '活动门槛:', name: 'activityType' },
                { type: 'input', label: '活动地点:', name: 'location' },
                { type: 'datetime', label: '开始时间:', name: 'startTime' },
                { type: 'datetime', label: '结束时间:', name: 'endTime' },
            ],
        }
    },
    mounted() {
        setTimeout(() => {
            this.loadingData()
        }, 300)
    },
    methods: {
        isOk(res) {
            return res && res.data && (res.data.code == '200' || res.data.code === 200)
        },
        tableHeaderColor({ rowIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        buildQuery() {
            const data = { ...this.conditionData }
            Object.keys(data).forEach(key => {
                if (data[key] === '' || data[key] === null || data[key] === undefined) {
                    delete data[key]
                }
            })
            return data
        },
        async loadingData() {
            const res = await api.activityGetPage(this.buildQuery())
            if (this.isOk(res)) {
                const data = res.data.data || {}
                this.tableData = data.records || data.list || (Array.isArray(data) ? data : [])
                this.totalCount = data.total || 0
            }
        },
        selectData() {
            this.conditionData.current = 1
            this.loadingData()
        },
        reset() {
            this.conditionData = {
                userId: '',
                activityType: '',
                startTime: '',
                endTime: '',
                location: '',
                theme: '',
                current: 1,
                size: 10,
            }
            this.loadingData()
        },
        handleCurrentChange(current) {
            this.conditionData.current = current
            this.loadingData()
        },
        handleSizeChange(size) {
            this.conditionData.current = 1
            this.conditionData.size = size
            this.loadingData()
        },
        async detailTip(row) {
            const res = await api.activityGetDetail({ id: row.id })
            if (this.isOk(res)) {
                this.detailData = res.data.data || {}
                this.isDetailDialog = true
            }
        },
        updateTip(row) {
            this.editData = {
                id: row.id,
                creationTime: row.creationTime || '',
                userId: row.userId,
                activityType: row.activityType || '',
                startTime: row.startTime || '',
                endTime: row.endTime || '',
                location: row.location || '',
                theme: row.theme || '',
                meetingPlace: row.meetingPlace || '',
                capacity: row.capacity || 0,
                content: row.content || '',
                maidan: row.maidan || '',
            }
            this.isUpdateDialog = true
        },
        async editFun() {
            const payload = {
                id: this.editData.id,
                creationTime: this.editData.creationTime || '',
                userId: this.editData.userId,
                activityType: this.editData.activityType || '',
                startTime: this.editData.startTime || '',
                endTime: this.editData.endTime || '',
                location: this.editData.location || '',
                theme: this.editData.theme || '',
                meetingPlace: this.editData.meetingPlace || '',
                capacity: Number(this.editData.capacity) || 0,
                content: this.editData.content || '',
                maidan: this.editData.maidan || '',
            }
            const res = await api.activityUpdate(payload)
            if (this.isOk(res)) {
                this.$message({ type: 'success', message: '编辑成功' })
                this.isUpdateDialog = false
                this.loadingData()
            }
        },
        deleteTip(row) {
            this.$confirm('将删除此活动，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.del(row)
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消' })
            })
        },
        async del(row) {
            const res = await api.activityDelete(row.id)
            if (this.isOk(res)) {
                this.$message({ type: 'success', message: '删除成功' })
                this.loadingData()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.condition {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    border-radius: 5px;
    padding: 15px;
    font-size: 14px;
}
.table {
    margin-top: 10px;
    background-color: #ffffff;
    padding: 15px;
    .handle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 15px;
        align-items: center;
        font-size: 20px;
    }
    .page {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
    }
}
.user-cell {
    display: flex;
    align-items: center;
    justify-content: center;
}
.dialog {
    .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .label {
            width: 100px;
            flex-shrink: 0;
            text-align: right;
            padding-right: 12px;
            color: #606266;
        }
        .value {
            flex: 1;
            color: #303133;
            word-break: break-all;
        }
        .content {
            white-space: pre-wrap;
            line-height: 1.6;
        }
    }
    .item-top {
        align-items: flex-start;
        .label {
            padding-top: 6px;
        }
    }
    .btns {
        text-align: center;
    }
}
.detail .item {
    margin-bottom: 12px;
}
</style>
